// V1-COMPAT: the name react18_component/react18_mount.js mount as "V1ExpertShow" -- the copied V2
// ExpertTopLevelShow (experts/expert_top_level_show.jsx) wrapped with the entity-resolution glue
// (with_v2_entity.jsx, resolving `experts.migrate_id` to its V2 `id`) and the V2 identity glue
// (with_v2_identity.jsx), so a signed-in V1 viewer gets the same identity-gated features V2 hosts
// itself. Mounted by Frontend::SourcesController#show once it resolves the :v2 render.
import withV2Identity from './with_v2_identity';
import withV2Entity from './with_v2_entity';
import ExpertTopLevelShow from '../experts/expert_top_level_show';

// blockUntilSettled/normalizeViewerContextOnFailure: true -- see with_v2_identity.jsx's module
// comment. This show page already blocks on its own entity resolution, so withholding the mount
// until identity has settled too costs nothing extra; normalizing viewerContext on a settled
// failure keeps a signed-in viewer from ever seeing a page that mixes an authenticated
// viewerContext with cleared identity globals.
const V1ExpertShow = withV2Identity(withV2Entity(ExpertTopLevelShow, {
  apiTable: 'experts',
  idColumn: 'migrate_id',
  idPropName: 'expertId',
}), { blockUntilSettled: true, normalizeViewerContextOnFailure: true });

export default V1ExpertShow;
